import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import FeaturesCard from "../../components/client/FeaturesCard";
import DownloadAppCard from "../../components/client/DownloadAppCard";
import PromotionalSlider from "../../components/client/PromotionalSlider";
import PopularCategories from "../../components/client/PopularCategories";
import PromotionalBanners from "../../components/client/PromotionalBanners";
import TrendingProducts from "../../components/client/TrendingProducts";
import ClientLayout from "../../layouts/ClientLayout";

const Home = () => {
  const navigate = useNavigate();

  return (
    <ClientLayout>
      <div className="flex-1 md:mx-8 lg:mx-16 mx-auto">
        <PromotionalSlider />
        <FeaturesCard />
        <PopularCategories />
        <TrendingProducts />

        <DownloadAppCard />
        <PromotionalBanners />
      </div>
    </ClientLayout>
  );
};

export default Home; 